import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function ModalInfoList({ withIcons = false, className = "", children }) {
    const cols = withIcons
        ? "grid-cols-[1.25rem_auto_minmax(0,1fr)]"
        : "grid-cols-[auto_minmax(0,1fr)]";

    return (
        <div className={`grid ${cols} items-center gap-x-3 gap-y-1.5 text-sm ${className}`.trim()}>
            {children}
        </div>
    );
}

export function ModalInfoRow({
    icon,
    iconClass,
    iconStyle,
    label,
    children,
    valueStyle,
}) {
    return (
        <>
            {icon ? (
                <span className="flex size-5 items-center justify-center">
                    <FontAwesomeIcon
                        icon={icon}
                        className={`text-sm ${iconClass || "text-mute-500"}`}
                        style={iconStyle}
                    />
                </span>
            ) : null}
            <span className="whitespace-nowrap text-mute-500">{label}:</span>
            <span className="min-w-0" style={valueStyle}>
                {children}
            </span>
        </>
    );
}
